import { ITypedReduxAction } from '../../types/redux';

export enum EBuildersProjectsLocationsActionTypes {
  SetData = 'buildersProjectsLocations/set-data',
}

export type TSetBuildersProjectsLocations = ITypedReduxAction<EBuildersProjectsLocationsActionTypes.SetData, number[]>;

export type TBuildersProjectsLocationsActions = TSetBuildersProjectsLocations;
